import React, { useState } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import { canCreateGroup } from 'srcReact/helpers/userHelper'
import { isNativeIOS } from 'srcReact/helpers/utils'
import MobileModal from 'srcReact/components/common2/MobileModal'
import CreatePopup from 'srcReact/components/common2/Navigation/SideBarMain/components/CreatePopup'

function SideBarMainMobile({
  currentOrganization,
  feedActive,
  homeActive,
  discoverActive,
  calendarActive,
  mixrHomeActive,
  groupHomeActive,
  isNative
}) {
  const { t } = useTranslation()

  const [isCreatePopupOpen, setIsCreatePopupOpen] = useState(false)

  const handleRedirect = (page) => {
    redirectToPage(page, isNative)
  }
  const openCreatePopup = () => {
    setIsCreatePopupOpen(true)
  }
  const closeCreatePopup = () => {
    setIsCreatePopupOpen(false)
  }
  const hasPermissionCreateGroupMixr = currentOrganization && canCreateGroup(currentOrganization)
  /* If the current location matches the patterns "/home/event" and "/home/group" respectively. 
  If the location matches the pattern, the corresponding variable `mixrHomeActive` or `groupHomeActive`will be set to `true` */
  const hasGroupOrMixrHomePage = mixrHomeActive || groupHomeActive

  return (
    <aside
      className={`${styles.sideMobileContainer} ${hasGroupOrMixrHomePage && styles.sideMobileContainer2} ${
        !hasPermissionCreateGroupMixr && styles.hasNotPermissionCreateGroupMixr
      }`}
      aria-label={t('nav.sidemenu')}>
      {!hasGroupOrMixrHomePage && (
        <div className={styles.left}>
          <button
            id='onboarding_myhome'
            onClick={() => handleRedirect('/0/myhome')}
            className={`${styles.link} ${homeActive && styles.selected}`}>
            {homeActive && <div className={styles.selectedDiv}></div>}
            <Icon name={homeActive ? 'myHome-colored' : 'myHome-grayed'} />
            <span className={homeActive ? styles.selectedText : styles.text}>{t('sidebar.home')}</span>
          </button>
          <button
            id='onboarding_feed'
            onClick={() => handleRedirect('/0/feed')}
            className={`${styles.link} ${feedActive && styles.selected}`}>
            {feedActive && <div className={styles.selectedDiv}></div>}
            <Icon name={feedActive ? 'feed-coloured' : 'Feed-Grayed'} />
            <span className={feedActive ? styles.selectedText : styles.text}>{t('sidebar.feed')}</span>
          </button>
        </div>
      )}
      {hasPermissionCreateGroupMixr && (
        <div className={styles.center}>
          <button
            aria-label={t('formlabel.createMixrGroup')}
            className={`${styles.createButton} ${isNative && styles.isNative}`}
            onClick={openCreatePopup}>
            <Icon name='add' />
          </button>
        </div>
      )}
      {!hasGroupOrMixrHomePage && (
        <div className={styles.right}>
          <button
            id='onboarding_discover'
            onClick={() => handleRedirect('/0/discover')}
            className={`${styles.link} ${discoverActive && styles.selected}`}>
            {discoverActive && <div className={styles.selectedDiv}></div>}
            <Icon name={discoverActive ? 'discover-coloured' : 'discover-grayed'} />
            <span className={discoverActive ? styles.selectedText : styles.text}>{t('sidebar.discover')}</span>
          </button>
          <button
            id='onboarding_calendar'
            onClick={() => handleRedirect('/0/calendar')}
            className={`${styles.link} ${calendarActive && styles.selected}`}>
            {calendarActive && <div className={styles.selectedDiv}></div>}
            <Icon name={calendarActive ? 'calendar-colored' : 'Calendar-grayed'} />
            <span className={calendarActive ? styles.selectedText : styles.text}>{t('sidebar.calendar')}</span>
          </button>
        </div>
      )}
      {isCreatePopupOpen && (
        <MobileModal
          showBackArrow={false}
          showDraggableDiv={true}
          closeOnDocumentClick={true}
          className='isCreatePopup'
          customContentStyle={{
            height: mixrHomeActive
              ? isNativeIOS()
                ? '35vh'
                : '40vh'
              : groupHomeActive
              ? isNativeIOS()
                ? '50vh'
                : '55vh'
              : '65vh'
          }}
          isOpen={isCreatePopupOpen}
          headerCSS={styles.headerCSS}
          handleClose={closeCreatePopup}>
          <CreatePopup
            handleClose={closeCreatePopup}
            isNative={isNative}
            hasGroupOrMixrHomePage={hasGroupOrMixrHomePage}
            mixrHomeActive={mixrHomeActive}
          />
        </MobileModal>
      )}
      {/* {isCreatePopupOpen && (
        <Popup
          open={isCreatePopupOpen}
          onClose={closeCreatePopup}
          contentStyle={{ background: 'transparent', border: '0', width: '100vw' }}
          overlayStyle={{ background: 'rgba(250, 250, 255, 0.8)', backdropFilter: 'blur(4px)' }}>
          <CreatePopup handleClose={closeCreatePopup} isNative={isNative} />
        </Popup>
      )} */}
    </aside>
  )
}

export default SideBarMainMobile
